import DepositsService from '../../services/DepositsService';
import toast from 'react-hot-toast';

// Action Types
export const DEPOSITS_LOADING_TOGGLE = '[Deposits] Loading Toggle';
export const GET_DEPOSITS_SUCCESS = '[Deposits] Get Deposits Success';
export const GET_DEPOSITS_FAILED = '[Deposits] Get Deposits Failed';
export const GET_DEPOSIT_BY_ID_SUCCESS = '[Deposits] Get Deposit By ID Success';
export const GET_DEPOSIT_BY_ID_FAILED = '[Deposits] Get Deposit By ID Failed';
export const CREATE_DEPOSIT_SUCCESS = '[Deposits] Create Deposit Success';
export const CREATE_DEPOSIT_FAILED = '[Deposits] Create Deposit Failed';
export const UPDATE_DEPOSIT_SUCCESS = '[Deposits] Update Deposit Success';
export const UPDATE_DEPOSIT_FAILED = '[Deposits] Update Deposit Failed';
export const CLOSE_DEPOSIT_SUCCESS = '[Deposits] Close Deposit Success';
export const CLOSE_DEPOSIT_FAILED = '[Deposits] Close Deposit Failed';
export const GET_DEPOSIT_HISTORY_SUCCESS = '[Deposits] Get Deposit History Success';
export const GET_DEPOSIT_HISTORY_FAILED = '[Deposits] Get Deposit History Failed';
export const GET_DEPOSITS_DROPDOWN_SUCCESS = '[Deposits] Get Deposits Dropdown Success';
export const GET_DEPOSITS_DROPDOWN_FAILED = '[Deposits] Get Deposits Dropdown Failed';
export const GET_DEPOSITOR_DEPOSIT_SUMMARY_SUCCESS = '[Deposits] Get Depositor Deposit Summary Success';
export const GET_DEPOSITOR_DEPOSIT_SUMMARY_FAILED = '[Deposits] Get Depositor Deposit Summary Failed';
export const CREATE_DEPOSIT_TRANSACTION_SUCCESS = '[Deposits] Create Deposit Transaction Success';
export const CREATE_DEPOSIT_TRANSACTION_FAILED = '[Deposits] Create Deposit Transaction Failed';
export const GET_DEPOSIT_INTEREST_HISTORY_SUCCESS = '[Deposits] Get Deposit Interest History Success';
export const GET_DEPOSIT_INTEREST_HISTORY_FAILED = '[Deposits] Get Deposit Interest History Failed';
export const UPDATE_INTEREST_RATE_SUCCESS = '[Deposits] Update Interest Rate Success';
export const UPDATE_INTEREST_RATE_FAILED = '[Deposits] Update Interest Rate Failed';
export const CLEAR_DEPOSIT_ERRORS = '[Deposits] Clear Errors';
export const RESET_DEPOSIT_SUCCESS = '[Deposits] Reset Success State';

// Action Creators
export function depositsLoadingToggle(status) {
    return {
        type: DEPOSITS_LOADING_TOGGLE,
        payload: status,
    };
}

export function getDepositsAction(params = {}) {
    return async (dispatch) => {
        dispatch(depositsLoadingToggle(true));
        try {
            const response = await DepositsService.getAllDeposits(params);
            dispatch({
                type: GET_DEPOSITS_SUCCESS,
                payload: response
            });
        } catch (error) {
            dispatch({
                type: GET_DEPOSITS_FAILED,
                payload: error.response?.data?.message || 'Failed to fetch deposits'
            });
        } finally {
            dispatch(depositsLoadingToggle(false));
        }
    };
}

export function getDepositByIdAction(id) {
    return async (dispatch) => {
        dispatch(depositsLoadingToggle(true));
        try {
            const response = await DepositsService.getDepositById(id);
            dispatch({
                type: GET_DEPOSIT_BY_ID_SUCCESS,
                payload: response
            });
        } catch (error) {
            dispatch({
                type: GET_DEPOSIT_BY_ID_FAILED,
                payload: error.response?.data?.message || 'Failed to fetch deposit'
            });
        } finally {
            dispatch(depositsLoadingToggle(false));
        }
    };
}

export function createDepositAction(depositData, callback) {
    return async (dispatch) => {
        dispatch(depositsLoadingToggle(true));
        try {
            const response = await DepositsService.createDeposit(depositData);
            if(response && response.success === true){
                dispatch({
                    type: CREATE_DEPOSIT_SUCCESS,
                    payload: response
                });
                if (callback) {
                    callback(response.message || "Deposit created successfully", {}, true);
                }
            } else {
                dispatch({
                    type: CREATE_DEPOSIT_FAILED,
                    payload: response.message || 'Failed to create deposit'
                });
                dispatch({
                    type: 'CREATE_DEPOSIT_ERROR',
                    payload: response.message
                });
                if (callback) {
                    callback(response.message, {}, false);
                }
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Failed to create deposit';
            dispatch({
                type: CREATE_DEPOSIT_FAILED,
                payload: errorMessage
            });
            dispatch({
                type: 'CREATE_DEPOSIT_ERROR',
                payload: errorMessage
            });
            if (callback) {
                    callback(errorMessage, {}, false);
            }
        } finally {
            dispatch(depositsLoadingToggle(false));
        }
    };
}

export function updateDepositAction(id, updateData, callback) {
    return async (dispatch) => {
        dispatch(depositsLoadingToggle(true));
        try {
            const response = await DepositsService.updateDeposit(id, updateData);
            if (response && response.success === true) {
                dispatch({
                    type: UPDATE_DEPOSIT_SUCCESS,
                    payload: response
                });
                dispatch(resetDepositSuccess());
                if (callback) {
                    callback(response.message || "Deposit updated successfully");
                }
            } else {
                dispatch({
                    type: UPDATE_DEPOSIT_FAILED,
                    payload: response.message || 'Failed to update deposit'
                });
                dispatch({
                    type: 'UPDATE_DEPOSIT_ERROR',
                    payload: response.message || "Failed to update deposit"
                });
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Failed to update deposit';
            dispatch({
                type: UPDATE_DEPOSIT_FAILED,
                payload: errorMessage
            });
            dispatch({
                type: 'UPDATE_DEPOSIT_ERROR',
                payload: errorMessage
            });
        } finally {
            dispatch(depositsLoadingToggle(false));
        }
    };
}

export function closeDepositAction(id, callback) {
    return async (dispatch) => {
        dispatch(depositsLoadingToggle(true));
        try {
            const response = await DepositsService.closeDeposit(id);
            if (response && response.success === true) {
                dispatch({
                    type: CLOSE_DEPOSIT_SUCCESS,
                    payload: response
                });
                dispatch(resetDepositSuccess());
                if (callback) {
                    callback(response.message || "Deposit closed successfully");
                }
            } else {
                dispatch({
                    type: CLOSE_DEPOSIT_FAILED,
                    payload: response.message || 'Failed to close deposit'
                });
                dispatch({
                    type: 'CLOSE_DEPOSIT_ERROR',
                    payload: response.message || "Failed to close deposit"
                });
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Failed to close deposit';
            dispatch({
                type: CLOSE_DEPOSIT_FAILED,
                payload: errorMessage
            });
            dispatch({
                type: 'CLOSE_DEPOSIT_ERROR',
                payload: errorMessage
            });
        } finally {
            dispatch(depositsLoadingToggle(false));
        }
    };
}

export function getDepositHistoryAction(id, params = {}) {
    return async (dispatch) => {
        dispatch(depositsLoadingToggle(true));
        try {
            const response = await DepositsService.getDepositHistory(id, params);
            dispatch({
                type: GET_DEPOSIT_HISTORY_SUCCESS,
                payload: response
            });
        } catch (error) {
            dispatch({
                type: GET_DEPOSIT_HISTORY_FAILED,
                payload: error.response?.data?.message || 'Failed to fetch deposit history'
            });
        } finally {
            dispatch(depositsLoadingToggle(false));
        }
    };
}

export function getDepositsDropdownAction(branchId) {
    return async (dispatch) => {
        dispatch(depositsLoadingToggle(true));
        try {
            const response = await DepositsService.getDepositsDropdown(branchId);
            dispatch({
                type: GET_DEPOSITS_DROPDOWN_SUCCESS,
                payload: response
            });
        } catch (error) {
            dispatch({
                type: GET_DEPOSITS_DROPDOWN_FAILED,
                payload: error.response?.data?.message || 'Failed to fetch deposits dropdown'
            });
        } finally {
            dispatch(depositsLoadingToggle(false));
        }
    };
}

export function getDepositorDepositSummaryAction() {
    return async (dispatch) => {
        dispatch(depositsLoadingToggle(true));
        try {
            const response = await DepositsService.getDepositorDepositSummary();
            dispatch({
                type: GET_DEPOSITOR_DEPOSIT_SUMMARY_SUCCESS,
                payload: response
            });
        } catch (error) {
            dispatch({
                type: GET_DEPOSITOR_DEPOSIT_SUMMARY_FAILED,
                payload: error.response?.data?.message || 'Failed to fetch deposit summary'
            });
        } finally {
            dispatch(depositsLoadingToggle(false));
        }
    };
}

export function clearDepositErrors() {
    return {
        type: CLEAR_DEPOSIT_ERRORS
    };
}

export function resetDepositSuccess() {
    return {
        type: RESET_DEPOSIT_SUCCESS
    };
}

export function createDepositTransactionAction(depositId, transactionData) {
    return async (dispatch) => {
        dispatch(depositsLoadingToggle(true));
        try {
            const response = await DepositsService.createDepositTransaction(depositId, transactionData);
            
            if (response && response.success === true) {
                dispatch({
                    type: CREATE_DEPOSIT_TRANSACTION_SUCCESS,
                    payload: response.data
                });
                toast.success(response.message || "Transaction added successfully");
                dispatch(resetDepositSuccess());
                // Refresh deposit history to show the new transaction
                dispatch(getDepositHistoryAction(depositId));
                return Promise.resolve(response);
            } else {
                dispatch({
                    type: CREATE_DEPOSIT_TRANSACTION_FAILED,
                    payload: response.message || 'Failed to create transaction'
                });
                toast.error(response.message || "Failed to create transaction");
                return Promise.reject(response);
            }
        } catch (error) {
            dispatch({
                type: CREATE_DEPOSIT_TRANSACTION_FAILED,
                payload: error.response?.data?.message || 'Failed to create transaction'
            });
            toast.error(error.response?.data?.message || 'Failed to create transaction');
            return Promise.reject(error);
        } finally {
            dispatch(depositsLoadingToggle(false));
        }
    };
}

export function getDepositInterestHistoryAction(id, params = {}) {
    return async (dispatch) => {
        dispatch(depositsLoadingToggle(true));
        try {
            const response = await DepositsService.getDepositInterestHistory(id, params);
            dispatch({
                type: GET_DEPOSIT_INTEREST_HISTORY_SUCCESS,
                payload: response
            });
        } catch (error) {
            dispatch({
                type: GET_DEPOSIT_INTEREST_HISTORY_FAILED,
                payload: error.response?.data?.message || 'Failed to fetch interest history'
            });
        } finally {
            dispatch(depositsLoadingToggle(false));
        }
    };
}

export function updateInterestRateAction(depositId, interestData) {
    return async (dispatch) => {
        dispatch(depositsLoadingToggle(true));
        try {
            const response = await DepositsService.updateInterestRate(depositId, interestData);
            
            if (response && response.success === true) {
                dispatch({
                    type: UPDATE_INTEREST_RATE_SUCCESS,
                    payload: response.data
                });
                toast.success(response.message || "Interest rate updated successfully");
                dispatch(resetDepositSuccess());
                // Refresh interest history to show the new rate
                dispatch(getDepositInterestHistoryAction(depositId));
                return Promise.resolve(response);
            } else {
                dispatch({
                    type: UPDATE_INTEREST_RATE_FAILED,
                    payload: response.message || 'Failed to update interest rate'
                });
                toast.error(response.message || "Failed to update interest rate");
                return Promise.reject(response);
            }
        } catch (error) {
            dispatch({
                type: UPDATE_INTEREST_RATE_FAILED,
                payload: error.response?.data?.message || 'Failed to update interest rate'
            });
            toast.error(error.response?.data?.message || 'Failed to update interest rate');
            return Promise.reject(error);
        } finally {
            dispatch(depositsLoadingToggle(false));
        }
    };
}
